import * as z from 'zod/v4';

export const winDivisionSchema = z.number().positive().brand<'WinDivision'>();

export type WinDivision = z.infer<typeof winDivisionSchema>;
